/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: callbackRulesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the PBX Applications module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { buildApiUrl, getApiHeaders } from '../../config/api';

/**
 * Shared helpers for Callback Rules module actions (used in Grid + Form views).
 */

/**
 * Build the URL used to duplicate a Callback Rule in the form.
 * Pattern: /pbx/applications/callback/new?duplicate={id}
 */
export const getCallbackRuleDuplicateUrl = (id: string | number): string =>
  `/pbx/applications/callback/new?duplicate=${id}`;

/**
 * Navigate to the form in duplicate mode for the given Callback Rule id.
 */
export const navigateToCallbackRuleDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getCallbackRuleDuplicateUrl(id));
};

/**
 * Low-level API helper to delete a Callback Rule by id.
 * UI components are responsible for showing notifications and handling navigation/refresh.
 * @deprecated Use deleteCallbackRule from './api/callbackRulesApi' instead
 */
export const deleteCallbackRuleById = async (id: string | number): Promise<void> => {
  const { deleteCallbackRule } = await import('./api/callbackRulesApi');
  return deleteCallbackRule(id);
};



